import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { Provider } from "react-redux";
import store from "./store/index";
import { unregister } from './registerServiceWorker';

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>, 
	document.getElementById('root'));
	
unregister();



// WEBPACK FOOTER //
// ./src/index.js